export default {
  from: 'De',
  until: 'Até',
  rate: 'Percentual de Honorários',
  trash: 'Excluir Faixas',
};
